import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../../services/generalService";
import { ReverseDisbursalTransactionalObj } from "../../../utils/types";

const initialState: ReverseDisbursalTransactionalObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAllDisbursalTransaction = createAsyncThunk(
  "loans/getAllDisbursalTransaction",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const allDisbursalTransactionSlice = createSlice({
  name: "reverseDisbursalTrn",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDisbursalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllDisbursalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAllDisbursalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default allDisbursalTransactionSlice.reducer;
